export default __webpack_public_path__ + "static/media/screenshot_app_browse_purple.82eaf4fc.png";